<template>
  <div class="chat-box" ref="chatBox">
    <div class="box-con scrollbar" ref="scrollbarRef">
      <ul class="chat-list" ref="chatUlRef">
        <!-- 单条置顶提示 -->
        <div v-if="findTopFirst && topChatInfoFlag" class="chat-list-topfirst">
          <p class="topfirst-btn">{{ $t('chatroom.置顶') }}</p>
          <div class="topfirst-body">
            <div class="topfirst-content">
              <span>{{ findTopFirst.name }}：</span>
              <template v-if="findTopFirst.imgState">
                <img
                  v-if="findTopFirst.imgLinkUrl"
                  :src="findTopFirst.imgUrl"
                  class="chat-list-img"
                  @click="openLinkUrl(findTopFirst.imgLinkUrl)"
                />
                <img v-else :src="findTopFirst.imgUrl" class="chat-list-img" preview="1" />
              </template>
              <span
                style="white-space: pre-wrap"
                v-html="findTopFirst.body"
                :class="{ 'chat-highlight': findTopFirst.highlight }"
                v-if="findTopFirst.body"
              ></span>
            </div>
            <p class="topfirst-more pointer" @click="setScrolBarLocation(0)">
              {{ $t('chatroom.查看更多') }}
            </p>
          </div>
        </div>
        <!-- 聊天消息 -->
        <DynamicScroller
          ref="scroller"
          :items="chatList"
          :min-item-size="68"
          key-field="msgId"
          class="scrollbar scroller dynamicScroller"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
              :data-active="active"
            >
              <!-- 普通消息 -->
              <li
                :key="`chatItem${index}`"
                v-show="filterContent(item.body, item.imgState)"
                v-if="item.type === 'normal'"
                class="pointer"
                :class="{
                  'chat-list-right': item.uid == userInfo.uid,
                  'chat-list-left': item.uid != userInfo.uid,
                  showMore: item.handle
                }"
              >
                <div class="chat-content">
                  <h5 class="chat-list-name" v-if="item.uid != userInfo.uid">
                    <div class="chat-avatar">
                      <img :src="item.headImgUrl" v-if="item.headImgUrl" width="28" />
                      <img
                        v-else-if="['6', '7', '8'].includes(item.role + '')"
                        :src="require('@/svg/chatavatar_' + item.role + '.svg')"
                        width="28"
                      />
                      <img v-else :src="require('@/svg/default_chatavatar.svg')" width="28" />
                    </div>
                    <div
                      class="group-item-id"
                      v-if="
                        item.groupSerialNumbe &&
                        item.groupSerialNumbe != '' &&
                        item.groupSerialNumbe != '0'
                      "
                    >
                      <img :src="require('@/svg/group/group-icon.svg')" width="10px" />{{
                        item.groupSerialNumbe
                      }}
                    </div>
                    <div class="chat-item-top">
                      <span v-if="item.role == 6" class="chat-role">{{ $t('chatroom.主播') }}</span>
                      <span v-else-if="item.role == 7" class="chat-role">{{
                        $t('chatroom.嘉宾')
                      }}</span>
                      <span v-else-if="item.role == 8" class="chat-role">{{
                        $t('chatroom.助手')
                      }}</span>
                      <span class="chat-name" :title="item.name">{{ item.name }}</span>
                      <span>{{ dateFormat(new Date(item.ts), 'HH:mm') }}</span>
                    </div>
                    <el-button
                      style="
                        width: 40px;
                        height: 20px;
                        line-height: 20px;
                        padding: 0px;
                        font-size: 12px;
                        margin-left: 5px;
                      "
                      v-if="item.top != 0"
                      type="danger"
                      size="mini"
                      >{{ $t('chatroom.置顶') }}</el-button
                    >
                  </h5>
                  <h5 class="chat-list-name" v-else>
                    <el-button
                      style="
                        width: 40px;
                        height: 20px;
                        line-height: 20px;
                        padding: 0px;
                        font-size: 12px;
                        margin-left: 5px;
                      "
                      v-if="item.top != 0"
                      type="danger"
                      size="mini"
                      >{{ $t('chatroom.置顶') }}</el-button
                    >
                    <div class="chat-item-top">
                      <span>{{ dateFormat(new Date(item.ts), 'HH:mm') }}</span>
                      <span class="chat-name" :title="item.name">{{ item.name }}</span>
                      <span class="chat-role-5">{{ $t('chat.我') }}</span>
                    </div>
                    <div
                      class="group-item-id"
                      v-if="
                        item.groupSerialNumbe &&
                        item.groupSerialNumbe != '' &&
                        item.groupSerialNumbe != '0'
                      "
                    >
                      <img :src="require('@/svg/group/group-icon.svg')" width="10px" />{{
                        item.groupSerialNumbe
                      }}
                    </div>
                    <div class="chat-avatar">
                      <img :src="item.headImgUrl" v-if="item.headImgUrl" width="28" />
                      <img
                        v-else-if="['6', '7', '8'].includes(item.role + '')"
                        :src="require('@/svg/chatavatar_' + item.role + '.svg')"
                        width="28"
                      />
                      <img v-else :src="require('@/svg/default_chatavatar.svg')" width="28" />
                    </div>
                  </h5>
                  <div
                    class="chat-list-body"
                    :class="{
                      'chat-content-img': item.imgState,
                      'chat-highlight-body': item.highlight
                    }"
                  >
                    <template v-if="item.imgState">
                      <img
                        v-if="item.imgLinkUrl"
                        :src="item.imgUrl"
                        class="chat-list-img"
                        @click="openLinkUrl(item.imgLinkUrl)"
                        @load="scrollBottom()"
                      />
                      <img
                        v-else
                        :src="item.imgUrl"
                        class="chat-list-img"
                        preview="1"
                        @load="scrollBottom()"
                      />
                    </template>

                    <div
                      style="white-space: pre-wrap"
                      v-html="item.body"
                      :class="{
                        'chat-highlight': item.highlight,
                        'chat-link': item.isLink
                      }"
                      v-if="item.body"
                      @click="openLink(item)"
                    ></div>
                    <div class="chat-more" :id="`chat-more${index}`">
                      <span class="chat-reply" @click="replyFun(item)">{{ $t('chat.回复') }}</span>
                      <el-popover
                        v-if="
                          role == 3 ||
                          (item.uid == userInfo.uid && new Date().getTime() - item.ts < 30000)
                        "
                        placement="bottom"
                        width="72"
                        popper-class="tip-popconfirm chat-handle-popover"
                        trigger="manual"
                        v-model="item.handle"
                      >
                        <!-- 操作列表   -->
                        <ul
                          class="chat-handle-list"
                          @mouseenter="mouseenter(index, item)"
                          @mouseleave="item.handle = false"
                        >
                          <li v-for="(p, i) in handleOption" :key="i">
                            <span
                              v-if="
                                ((p.isShowTips == undefined &&
                                  !item[`${p.code}`] &&
                                  p.code != 'withdraw' &&
                                  p.code != 'kickOut' &&
                                  p.code != 'bannedToPost') ||
                                  (p.code == 'withdraw' &&
                                    item.uid == userInfo.uid &&
                                    item.role == 7 &&
                                    new Date().getTime() - item.ts < 30000) ||
                                  (p.code == 'bannedToPost' &&
                                    !item[`${p.code}`] &&
                                    item.role == 5)) &&
                                (role == 3 || p.code == 'withdraw')
                              "
                              @click="handleFun(p.code, item)"
                              >{{ $t(`chat['${p.code}']`) }}</span
                            >
                            <span
                              v-if="p.isShowTips == undefined && item[`${p.code}`]"
                              @click="handleFun(p.code, item)"
                              >{{ $t(`chat['cancel${p.code}']`) }}</span
                            >
                            <el-popover
                              v-if="p.isShowTips != undefined && item.role == 5"
                              placement="top"
                              width="120"
                              :append-to-body="false"
                              :visible-arrow="false"
                              class="dialog-dark kickOut"
                              v-model="p.isShowTips"
                            >
                              <p style="line-height: 40px">
                                {{ $t('chat.confirmkickOut') }}
                              </p>
                              <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="p.isShowTips = false">{{
                                  $t('chat.取消')
                                }}</el-button>
                                <el-button
                                  type="primary"
                                  size="mini"
                                  @click="handleFun(p.code, item)"
                                  >{{ $t('chat.确定') }}</el-button
                                >
                              </div>
                              <span slot="reference">{{ $t(`chat['${p.code}']`) }}</span>
                            </el-popover>
                          </li>
                        </ul>
                        <div
                          slot="reference"
                          class="chat-more-list"
                          @mouseleave="delayHideHandle(item)"
                          @click="operationFunc(item, $event)"
                          v-if="
                            role == 3 ||
                            (item.uid == userInfo.uid && new Date().getTime() - item.ts < 30000)
                          "
                        >
                          <svg
                            class="main-color"
                            version="1.1"
                            id="图层_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 80 40"
                            style="enable-background: new 0 0 80 40"
                            xml:space="preserve"
                          >
                            <g>
                              <circle cx="15" cy="20" r="7" />
                            </g>
                            <g>
                              <circle cx="38.5" cy="20" r="7" />
                            </g>
                            <g>
                              <circle cx="62" cy="20" r="7" />
                            </g>
                          </svg>

                          <!-- <img :src="require('@/svg/icon-list-more.svg')" /> -->
                        </div>
                      </el-popover>
                    </div>
                  </div>
                  <div v-if="item.quote" class="chat-quote-text">
                    <span>{{ item.quote.name }}:</span>
                    <img
                      v-if="item.quote.imgState"
                      :src="item.quote.imgUrl"
                      class="chat-list-img"
                    />
                    <span v-html="quteChatContent(item.quote.chatContent)" class="quateContent">
                    </span>
                  </div>
                </div>
              </li>
              <!-- 开启权限消息显示 -->
              <li :key="`chatItem${index}`" v-if="item.type === 'success'" class="tips">
                <span class="success">{{ item.msg }}</span>
              </li>
              <!-- 关闭权限消息显示 -->
              <li :key="`chatItem${index}`" v-if="item.type === 'error'" class="tips">
                <span class="error">{{ item.msg }}</span>
              </li>
              <!-- 已踢出消息显示 -->
              <li :key="`chatItem${index}`" v-if="item.type === 'info'" class="tips">
                <span class="info">{{ item.msg }}</span>
              </li>
              <!-- 已删除消息显示 -->
              <li :key="`chatItem${index}`" v-if="item.type === 'warning'" class="tips">
                <span class="warning">{{ item.msg }}</span>
              </li>
              <!-- 系统消息 -->
              <li :key="`chatItem${index}`" class="system-body" v-if="item.type === 'system'">
                <span class="fontsize12"
                  >{{ $t('chatroom.系统消息') }}：<span v-if="item.body.role">{{
                    $t(`chatroom.${item.body.role}`)
                  }}</span>
                  {{ item.body.name }}{{ $t(`chatroom.${item.body.text}`) }}</span
                >
              </li>
              <!-- 礼物 -->
              <li class="giftmsg-body" :key="`chatItem${index}`" v-if="item.type === 'giftMsg'">
                <span class="fontsize12"
                  ><span class="giftmsg-body-name">{{ item.body.nickName }}</span
                  >{{ $t('chatroom.赠送了一个') }}</span
                >
                <span v-if="item.body.giftType == '1'" class="fontsize12">{{
                  item.body.giftName
                }}</span>
                <span v-else class="fontsize12"
                  >{{ item.body.price / 100 }}{{ $t('chatroom.的现金') }}</span
                >
                <img
                  :src="require(`@/assets/images/gift/${item.body.giftPicUrl}.png`)"
                  v-if="defaultPicListId.includes(item.body.giftPicUrl)"
                />
                <img v-else :src="item.giftPicUrl" />
              </li>
              <!-- 红包 -->
              <li
                :key="`chatItem${index}`"
                v-if="item.type === 'redpacketMsg'"
                @click="openRedPacketDetail(item.body)"
                class="redpacketmsg-body"
              >
                <img :src="require('@/svg/redpacket_icon.svg')" />
                <span
                  ><span class="textHide" :title="item.body.nickname">{{ item.body.nickname }}</span
                  >{{ $t('redpacket.Receive') }}{{ $t('redpacket.le')
                  }}<span class="textHide" :title="item.body.userName">{{
                    item.body.userName
                  }}</span
                  >{{ $t('redpacket.de')
                  }}<span class="redpacketmsg-redcolor"
                    >{{ (item.body.amount / 100).toFixed(2) }}{{ $t('redpacket.yuan')
                    }}{{ $t('redpacket.redPacket') }}</span
                  ></span
                >
              </li>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <div class="chat-unread" v-show="unreadNum > 0" @click="scrollBottom">
          <i class="el-icon-d-arrow-right"></i>{{ unreadNum }}{{ $t('chatroom.条新消息') }}
        </div>
      </ul>
      <a
        v-show="unreadNum > 0 && atMsgIds.length > 0"
        class="at-message"
        @click="clickToPosition"
        >{{ $t('chatroom.有人@我') }}</a
      >
    </div>
    <div class="bottom-bar">
      <div class="bottom-bar-handle">
        <div>
          <el-popover
            v-if="role == 3"
            placement="top-start"
            width="162"
            :append-to-body="false"
            :visible-arrow="false"
            class="dialog-dark bottom-bar-control"
            popper-class="bar-offset-14"
            v-model="controlItem"
          >
            <div class="bottom-bar-switch fontsize12" style="margin-bottom: 10px">
              <span style="color: #b2b3bd">{{ $t('chat.观众聊天审核') }}</span>
            </div>
            <div class="bottom-bar-switch fontsize12" style="margin-bottom: 10px">
              <span class="fontColor">{{ $t('chat.文字审核') }}</span>
              <el-switch
                v-model="chatCheckState"
                @change="changeChatCheckState"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <div v-if="chatImages" class="bottom-bar-switch fontsize12" style="margin-bottom: 10px">
              <span class="fontColor">{{ $t('chat.图片审核') }}</span>
              <el-switch :value="true" :disabled="true" class="blueSwitch form-dark"> </el-switch>
            </div>
            <div
              class="el-divider"
              style="width: 100%; height: 1px; background: #353757; margin-bottom: 10px"
            ></div>
            <div class="bottom-bar-switch fontsize12">
              <span class="fontColor">{{ $t('chat.聊天禁言') }}</span>
              <el-switch
                v-model="allBannedToPost"
                @change="allBannedToPostChange"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <p class="fontsize12" style="color: #888999">
              {{ $t('chat.banspeaktojoiner') }}
            </p>
            <span slot="reference" class="bottom-bar-control-name mr12"
              >{{ $t('chat.控制项') }} <img :src="require('@/svg/pulldown.svg')"
            /></span>
          </el-popover>
          <span
            slot="reference"
            class="bottom-bar-control-name all-chat-select"
            @click="openChatSelect"
            >{{ $t(`chat.${chatText}`) }} <img :src="require('@/svg/pulldown.svg')"
          /></span>
        </div>
        <div class="chat-tool">
          <el-popover
            placement="top"
            width="160"
            :append-to-body="false"
            :visible-arrow="false"
            style="vertical-align: middle; line-height: 7px; display: inline-block"
            class="dialog-dark popover-position bottom-bar-control"
          >
            <p class="fontsize12" style="margin-bottom: 12px">
              {{ $t('chat.接收聊天消息') }}
            </p>
            <div class="bottom-bar-switch fontsize12" style="margin-bottom: 12px" v-if="role == 1">
              <span class="fontColor">{{ $t('chat.主播') }}</span>
              <el-switch
                v-model="chatCheckRole"
                @change="filterHistory"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <div class="bottom-bar-switch fontsize12" style="margin-bottom: 12px">
              <span class="fontColor">{{ $t('chat.助手') }}</span>
              <el-switch
                v-model="chatCheckAssiant"
                @change="filterHistory"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <div class="bottom-bar-switch fontsize12" style="margin-bottom: 12px">
              <span class="fontColor">{{ $t('chat.嘉宾') }}</span>
              <el-switch
                v-model="chatCheckGuest"
                @change="filterHistory"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <div class="bottom-bar-switch fontsize12">
              <span class="fontColor">{{ $t('chat.观众') }}</span>
              <el-switch
                v-model="chatCheckViewers"
                @change="filterHistory"
                class="blueSwitch form-dark"
              >
              </el-switch>
            </div>
            <el-divider></el-divider>
            <div class="bottom-bar-switch fontsize12">
              <span class="fontColor">{{ $t('chat.filterchat') }}</span>
              <el-switch v-model="messageFilterFlag" class="blueSwitch form-dark"> </el-switch>
            </div>
            <p class="fontsize12" style="margin-bottom: 12px">
              {{ $t('chat.filterchatTips') }}
            </p>
            <span slot="reference" class="bottom-bar-control-name">
              <img :src="require('@/svg/filter_icon.svg')"
            /></span>
          </el-popover>
          <span @click="showMoreFun" v-if="role == 3">
            <span style="color: rgba(2555, 255, 255, 0.1)">&nbsp;|&nbsp;</span
            ><a href="javascript:;">
              <!-- <img :src="require('@/svg/more-chat.svg')"/> -->
              <svg
                width="18px"
                height="14px"
                viewBox="0 0 18 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>编组</title>
                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g
                    id="CLA-内容筛选2"
                    transform="translate(-2218.000000, -984.000000)"
                    class="more-chat"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g id="编组" transform="translate(2218.000000, 984.000000)">
                      <path
                        d="M9,0.5 C8.17157288,0.5 7.5,1.14670107 7.5,1.94444727 C7.5,2.74219346 8.17157288,3.38889453 9,3.38889453 C9.82842712,3.38889453 10.5,2.74219346 10.5,1.94444727 C10.5,1.14670107 9.82842712,0.5 9,0.5 Z M7.5,12.0555527 C7.5,12.8532989 8.17157288,13.5 9,13.5 C9.82842712,13.5 10.5,12.8532989 10.5,12.0555527 C10.5,11.2578065 9.82842712,10.6111055 9,10.6111055 C8.17157288,10.6111055 7.5,11.2578065 7.5,12.0555527 Z M7.5,7 C7.5,7.7977462 8.17157288,8.44444727 9,8.44444727 C9.82842712,8.44444727 10.5,7.7977462 10.5,7 C10.5,6.2022538 9.82842712,5.55555273 9,5.55555273 C8.17157288,5.55555273 7.5,6.2022538 7.5,7 Z"
                        id="形状"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </span>
        </div>
        <ul v-if="showMore" class="more-chat-tool" v-click-outside="closeMore">
          <li>
            <span v-if="role == 3" @click="downloadExcelFunc" class="bottom-bar-control-name">{{
              $t('chat.下载聊天')
            }}</span>
          </li>
          <li>
            <span
              v-if="role == 3"
              slot="reference"
              class="bottom-bar-control-name"
              @click="openSensitiveWord = true"
              style="vertical-align: middle; line-height: 7px; display: inline-block"
            >
              {{ $t('chat.敏感词设置') }}
            </span>
          </li>
          <li>
            <el-popover
              v-if="role == 3"
              placement="top"
              width="200"
              :offset="30"
              :append-to-body="false"
              :visible-arrow="false"
              class="dialog-dark popover-position"
              v-model="emptyChatVisible"
            >
              <p style="line-height: 40px">{{ $t('chat.cleraAllChatTips') }}</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="emptyChatVisible = false">{{
                  $t('chat.取消')
                }}</el-button>
                <el-button type="primary" size="mini" @click="emptyChatFunc">{{
                  $t('chat.确定')
                }}</el-button>
              </div>
              <span slot="reference" class="bottom-bar-control-name">{{ $t('chat.清屏') }}</span>
            </el-popover>
          </li>
        </ul>
        <ul class="chat-select" v-click-outside="closeChatSelect" v-if="openSelect">
          <li @click="changeChat(0)" class="fontColor">{{ $t('chat.全部聊天') }}</li>
          <li @click="changeChat(1)" class="fontColor">{{ $t('chat.只看我') }}</li>
          <li @click="changeChat(2)" class="fontColor">{{ $t('chat.只看高亮') }}</li>
        </ul>
      </div>
      <div class="bottom-send-msg">
        <div
          class="chat-edit scrollbar"
          style="white-space: pre-wrap"
          ref="chatMessageRef"
          contenteditable
          :placeholder="$t('chatroom.输入消息')"
          @keydown="controlMaxLength($event)"
          @input="changeText($event)"
          @paste="handlePaste($event)"
          @keyup="checkForAtSign"
        ></div>
        <div class="bottom-bar-handel">
          <div class="bottom-bar-img">
            <img class="bottom-bar-emoji mr10" :src="require('@/svg/icon-emoji.svg')" />
            <!-- 发送图片 -->
            <el-tooltip :content="$t('chatroom.图片')" placement="top-start">
              <img :src="require('@/svg/icon-img.svg')" @click="openUploadImg = true" />
            </el-tooltip>
            <ul class="emoji-list">
              <li v-for="(item, sub) in emojiListArr" :key="sub" @click="emojiClick(item)">
                <img :codes="item.codes" :src="emojiUrl(item)" class="emojiItem" />
              </li>
            </ul>
          </div>
          <div class="bottom-bar-btn">
            <span style="color: #fff; font-size: 13px" class="fontColor"
              >{{ sendChatNumber }}/140</span
            >
            &nbsp;&nbsp;
            <el-button size="mini" @click="releaseFun" :disabled="sendChatNumber == 0">{{
              $t('chat.发送')
            }}</el-button>
          </div>
        </div>
        <!-- @列表-->
        <ul v-show="atList" class="user-list" id="listContent">
          <li
            v-for="(item, index) in filterAtList"
            :key="index"
            @click="selectUser(item)"
            :class="{ selected: index === 0 }"
          >
            <!-- <a class="user-list-a">        -->
            <img :src="item.headImgUrl" v-if="item.headImgUrl" width="20" />
            <img
              v-else-if="['6', '7', '8'].includes(item.role + '')"
              :src="require('@/svg/chatavatar_' + item.role + '.svg')"
              width="20"
            />
            <img v-else :src="require('@/svg/default_chatavatar.svg')" width="20" />
            <span class="list-name">{{ item.name || item.nickName }}</span>
            <!-- </a> -->
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      class="dialog-dark"
      :title="$t('chat.回复')"
      :before-close="closeReply"
      :visible.sync="openReply"
      :close-on-click-modal="false"
      width="400px"
    >
      <div v-if="quoteMessage">
        <div class="reply-name">
          <p>{{ quoteMessage.name }}：</p>
          <img v-if="quoteMessage.imgState" :src="quoteMessage.imgUrl" width="40" />
          <p
            style="white-space: pre-wrap; word-break: break-word"
            v-html="quoteMessage.chatContent"
            class="chat-list-body"
            v-if="quoteMessage.chatContent"
          ></p>
        </div>
        <div class="reply-content">
          <div
            class="chat-edit scrollbar"
            style="white-space: pre-wrap"
            contenteditable
            ref="replyChatMessageRef"
            :placeholder="$t('chat.inputreplycontent')"
            @keydown="controlMaxLength($event)"
            @input="changeText($event)"
            @paste="handlePaste($event)"
          ></div>
          <div class="reply-img pointer">
            <img :src="require('@/svg/icon-emoji.svg')" />
            <ul class="emoji-list" style="width: 275px">
              <li v-for="(item, sub) in emojiListArr" :key="sub" @click="emojiClick(item)">
                <img :codes="item.codes" :src="emojiUrl(item)" class="emojiItem" />
              </li>
            </ul>
          </div>
          <span class="limitlength" style="font-size: 13px">{{ sendChatNumber }}/140</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReply" size="mini" class="button-mini">{{
          $t('chat.取消')
        }}</el-button>
        <el-button type="primary" @click="releaseFun" size="mini" :disabled="sendChatNumber == 0">{{
          $t('chat.确定')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-drag
      class="dialog-dark check-dialog"
      :title="`${$t('chat.聊天审核')}`"
      :visible.sync="chatCheckShow"
      v-if="role == 3"
      width="454px"
      custom-class="check1-dialog"
      :modal="false"
      @close="showAsideAudit = true"
    >
      <span class="dialog-header">
        <img
          :src="require('@/assets/images/chat_expand.png')"
          width="17"
          @click="
            chatCheckShow = false;
            showAsideAudit = true;
          "
        />
      </span>
      <!-- <DynamicScroller
        ref="scrollerAuditList"
        :items="auditListFilter"
        :min-item-size="68"
        key-field="msgId"
        class="chat-audio-list scrollbar"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
            :data-active="active"
          > -->
      <ul class="chat-audio-list scrollbar" ref="scrollerAuditList">
        <li :key="item.id" v-for="item in auditListFilter">
          <div class="chat-audio-header fontColor">
            <span>{{ item.name }}：</span>
            <span v-if="item.imgState">
              <img class="chat-auditImg" preview="1" :src="item.imgUrl" alt="" />
            </span>
            <span v-else v-html="item.body"></span>
          </div>
          <div class="chat-audio-bottom">
            <span> {{ dateFormat(new Date(item.ts), 'HH:mm') }}</span>
            <div>
              <el-button
                class="radio-button-mini"
                size="mini"
                type="danger"
                plain
                @click="bannedToPostAndDelete(item)"
              >
                {{ $t('chat.bannedToPost') }}</el-button
              >
              <el-button
                class="radio-button-mini"
                size="mini"
                type="danger"
                plain
                @click="checkFunc(item, 0)"
              >
                {{ $t('chat.delte') }}</el-button
              >
              <el-button
                class="radio-button-mini"
                size="mini"
                type="primary"
                @click="checkFunc(item, 1)"
              >
                {{ $t('chat.pass') }}</el-button
              >
            </div>
          </div>
        </li>
      </ul>
      <img
        :src="require(`@/assets/images/blank/liaotianshenhe.png`)"
        v-if="auditListFilter.length == 0"
        class="noAuditList"
      />
      <!-- </DynamicScrollerItem>
        </template>
      </DynamicScroller> -->
      <p v-if="auditLoading" :class="[auditLoadingType == 0 ? 'audit-bottom' : 'audit-top']">
        <i class="el-icon-loading"></i>
        {{ $t('chat.loading') }}
      </p>
      <p
        class="chat-unread"
        v-if="noReadAudit"
        style="bottom: 80px"
        @click="getChatHistoryAuditListFunc('')"
      >
        <i class="el-icon-d-arrow-right"></i>{{ $t('chat.newauditmsg') }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-popconfirm
          icon="el-icon-info"
          placement="top"
          icon-color="#EA494B"
          :confirm-button-text="$t('chat.确定')"
          :cancel-button-text="$t('chat.取消')"
          popper-class="tip-popconfirm tip-popconfirm-lianmai"
          :title="$t('chat.deleteallaudittips')"
          @confirm="allCheckSuccessFunc(0)"
        >
          <el-button slot="reference" size="mini" type="danger">
            {{ $t('chat.全部删除') }}</el-button
          >
        </el-popconfirm>
        &nbsp;
        <el-button class="button-mini" type="primary" size="mini" @click="allCheckSuccessFunc(1)">
          {{ $t('chat.allpass') }}</el-button
        >
      </span>
    </el-dialog>
    <sensitiveWord :visible.sync="openSensitiveWord"></sensitiveWord>
    <div
      class="chat_audit pointer"
      v-if="(chatCheckState || chatImages) && showAsideAudit && role == 3"
      @click="
        chatCheckShow = true;
        showAsideAudit = false;
      "
    >
      <span class="fontsize12">{{ $t('chat.聊天审核') }}</span>
      <span class="auditList-length" v-if="auditMsgTips"></span>
      <img :src="require('@/assets/images/chat_packup.png')" width="11" />
    </div>
    <UploadImg :visible.sync="openUploadImg" />
  </div>
</template>

<script>
import {
  pushRoomControlFunc,
  pushRoomMessageFunc,
  removeMessageFunc
} from '@/utils/socketMessageDispose';
import {
  getChatHistoryList,
  downloadChat,
  getChatHistoryAuditList
} from '@/api/liveRequest/chatApi';
import { winkleUser } from '@/api/liveRequest/userApi';
import emojiList from '@/utils/emoji.json';
import sensitiveWord from '@/components/chatroom/sensitiveWord';
import vClickOutside from 'v-click-outside';
import { uuid, upSortcompare, downSortcompare, dateFormat } from '@/utils/global';
import Bus from '@/components/doc/bus';
import { Popover, Upload } from 'element-ui';
import ElTooltip from '../tooltip/ElTooltip.vue';
import UploadImg from './uploadImg.vue';
import { mapGetters } from 'vuex';
let chatContent = {
  type: 'normal',
  name: null,
  body: null,
  imgUrl: null,
  imgState: null,
  ucid: null,
  uid: null,
  from_dev: null,
  msgId: null,
  ts: null,
  role: null,
  handle: false,
  quote: null,
  cmd: null,
  top: 0,
  highlight: false,
  bannedToPost: false,
  headImgUrl: null,
  filter: true,
  groupSerialNumbe: '',
  isLink: false,
  imgLinkUrl: null
};
export default {
  name: 'chatRoomArea',
  data() {
    return {
      changeName: '',
      chatMessage: '',
      chatList: [],
      handleOption: [
        { code: 'withdraw' },
        { code: 'delte' },
        { code: 'delteAll' },
        { code: 'top' },
        { code: 'highlight' },
        { code: 'bannedToPost' },
        { code: 'kickOut', isShowTips: false }
      ],
      quoteMessage: null,
      allBannedToPost: false,
      // releaseState: false,
      /**群权限 */
      groupJurisdiction: {
        audit: 0, //是否开启审核   0->关闭   1->开启   -1->未设置，关闭 ,服务器默认-1
        auto_audit_time: 0, //设置自动审核时间，单位秒
        silence: 0, //是否禁言 1：禁言  0：不禁言-1：未设置 默认-1
        msg_clean_time: -1 //最近清空房间时间，时间戳，秒 1613973532> 0:时间戳 -1：未设置 默认-1
      },
      chatCheckShow: false,
      emptyChatVisible: false,
      messageFilterFlag: false, //短消息的开关
      deleteVisible: false, //删除二次弹窗
      scrollTop: 0,
      deleteItem: null,
      allFlag: false,
      sensitiveWord: false,
      chatCheckText: this.$t('chatroom.审核关闭'),
      calculateVal: 0,
      loadingState: false,
      moreMessageState: true,
      saveHighlightObj: [],
      saveTopObj: null,
      oldscrollLocationVal: 0,
      sendChatNumber: 0,
      fileList: [],
      uploadUrl: `${config.uploadUrl}/info/upload/deal`,
      topClientHeight: 0,
      bannedUserList: new Map(), //禁言用户列表
      defaultPicListId: [
        'giftIcon1',
        'giftIcon2',
        'giftIcon3',
        'giftIcon4',
        'giftIcon5',
        'giftIcon6',
        'giftIcon7',
        'hongbao'
      ],
      dateFormat: dateFormat,
      openReply: false,
      controlItem: false,
      chatCheckState: false, //聊天审核
      auditList: [],
      openSensitiveWord: false,
      showAsideAudit: false,
      firstScrollTimer: undefined,
      showMore: false,
      controlChat: false,
      openSelect: false,
      chatText: '全部聊天',
      chatCheckRole: true,
      chatCheckAssiant: true,
      chatCheckGuest: true,
      chatCheckViewers: true,
      filterAllC: true,
      filterMeC: false,
      filterHighLight: false,
      silence: 0,
      filterListBack: [],
      openUploadImg: false,
      tempChat: [],
      timeoutTimer: 0, //设置聊天显示等待时间
      joinAuditTime: 0, //进入聊天审核次数 cmd：6157
      initAuditStatus: false, //初始文字审核状态
      auditLoading: false,
      noReadAudit: false, //未读审核消息红点
      auditLoadingType: 0, //0：向下加载 1：向上加载
      auditMsgTips: false, //审核消息提示
      allAtList: [], //聊天@列表
      filterAtList: [], //查找显示的人
      atList: false, //是否显示@列表
      debounceTimeout: null,
      pickedName: '', //选择@的人
      pickedId: [], //@的人的id,可多个
      atIndex: 0, //@选择的人,加上下键选择改变这个index即可
      position: '', //当前的光标位置
      atLength: 1, //@后字符数
      atMsgIds: [] //收到的@的msgId集合，用于查找位置，计算个数，是否显示@我
    };
  },
  props: {
    show: Number
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    [Popover.name]: Popover,
    [Upload.name]: Upload,
    sensitiveWord,
    ElTooltip,
    UploadImg
  },
  computed: {
    ...mapGetters(['chatImages', 'JoinedList', 'audience']),
    emojiListArr() {
      return emojiList;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    chatRoomId() {
      return this.$store.getters.chatRoomId;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    dataObj() {
      return { siteId: '' };
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    },
    audit() {
      return this.$store.getters.audit;
    },
    findTopFirst() {
      return this.chatList.find((c) => {
        return c.top != 0;
      });
    },
    topChatInfoFlag() {
      //置顶消息浮窗是否出现
      return this.scrollTop > 75 ? true : false;
    },
    unreadNum() {
      return Math.max(this.chatList.length - this.oldscrollLocationVal, 0);
    },
    tophighlight() {
      return this.$store.getters.tophighlight;
    },
    quteChatContent() {
      return (chatInfo) => {
        //console.log(chatInfo, "chatInfo");
        return this.chatListHandle(chatInfo);
      };
    },
    teamId() {
      return this.$store.getters.teamId;
    },
    groupOrder() {
      return this.$store.getters.groupOrder;
    },
    auditListFilter() {
      return this.auditList.filter(
        (v) => this.chatCheckState || (!this.chatCheckState && v.imgState)
      );
    },
    firstInit() {
      return this.$store.getters.firstInit;
    }
  },
  created() {
    window.addEventListener('resize', this.scrollBottomUpdateCalc);
    pushRoomMessageFunc(this.getCvMcRoomMessage);
    pushRoomControlFunc(this.getCvMcRoomControl);
    if (this.liveToken) {
      this.getChatHistoryListFunc();
      this.auditList = [];
      this.getChatHistoryAuditListFunc();
    }
    if (this.audit) {
      this.getCvMcRoomControlChatRoom(this.audit);
    }
    this.init();
    if (this.tophighlight) {
      this.monitorTopOrHighlight(this.tophighlight);
    }
  },
  mounted() {
    this.handleScroll();

    //this.firstScrollTimer = setInterval(() => {
    this.scrollBottom();
    //}, 500);
  },
  beforeDestroy() {
    Bus.$off('systemMsg');
    removeMessageFunc(this.getCvMcRoomMessage);
    removeMessageFunc(this.getCvMcRoomControl);
  },
  watch: {
    chatRoomId: {
      handler(value) {
        if (value) {
          this.getChatHistoryListFunc();
          this.auditList = [];
          this.getChatHistoryAuditListFunc();
        }
      }
    },
    chatImages: {
      immediate: true,
      handler(val) {
        if (val) {
          this.chatCheckShow = false;
          this.showAsideAudit = true;
        }
      }
    },
    chatCheckState: {
      handler(value) {
        if (value && !this.initAuditStatus) {
          this.chatCheckShow = true;
          this.showAsideAudit = false;
        } else {
          this.chatCheckShow = false;
          this.showAsideAudit = true;
        }
      }
    },
    teamId: {
      handler(value) {
        console.log(value, 'value......');
        if (value) {
          this.chatList = [];
          this.filterListBack = [];
          // this.scrollBottom();
          this.getChatHistoryListFunc();
        }
      }
    },
    role(n) {
      if (n === 3) {
        this.chatCheckRole = true;
        this.filterHistory();
      }
    },
    chatCheckShow(n) {
      if (n) {
        this.$nextTick(() => {
          this.handleAuditScroll();
        });
        this.auditMsgTips = false;
        this.getChatHistoryAuditListFunc('');
      }
    }
  },
  methods: {
    openLink(item) {
      if (item.isLink) {
        window.open(item.body.trim());
      }
    },
    openLinkUrl(url) {
      window.open(url.trim());
    },
    filterHistory() {
      if (this.filterListBack.length === 0) {
        this.filterListBack = JSON.parse(JSON.stringify(this.chatList));
      }
      console.log(this.filterListBack, 'this.filterListBack');
      if (this.filterMeC) {
        this.chatList = this.filterMe(this.filterListBack);
      }
      if (this.filterAllC) {
        this.chatList = this.filterAll(this.filterListBack);
      }
      if (this.filterHighLight) {
        this.chatList = this.filterHigh(this.filterListBack);
      }
      console.log(this.filterListBack, this.chatList);
    },
    filterMe(list) {
      let meList = [];
      list.forEach((item) => {
        if (item.uid === this.userInfo.uid || item.top != 0) {
          meList.push(item);
        }
      });
      return meList;
    },
    filterAll(list) {
      let allList = [];
      list.forEach((v) => {
        // if (v.uid === this.userInfo.uid) {
        //   allList.push(v);
        // } else {
        if (
          v.uid === this.userInfo.uid ||
          (v.role == 6 && this.chatCheckRole) ||
          (v.role == 5 && this.chatCheckViewers) ||
          (v.role == 7 && this.chatCheckGuest) ||
          (v.role == 8 && this.chatCheckAssiant) ||
          v.type !== 'normal' ||
          v.top != 0
        ) {
          allList.push(v);
        }
        // }
      });
      return allList;
    },
    filterHigh(list) {
      let filterList = [];
      list.forEach((v) => {
        if (v.top > 0) {
          filterList.push(v);
        }
        if (v.highlight) {
          // if (v.uid === this.userInfo.uid) {
          //   filterList.push(v);
          // } else {
          if (
            v.uid === this.userInfo.uid ||
            (v.role == 6 && this.chatCheckRole) ||
            (v.role == 5 && this.chatCheckViewers) ||
            (v.role == 7 && this.chatCheckGuest) ||
            (v.role == 8 && this.chatCheckAssiant)
          ) {
            filterList.push(v);
          }
        }
      });
      return filterList;
    },
    filterMsg(msg) {
      if (this.filterMeC) {
        if (msg.from_uid === this.userInfo.uid) {
          return true;
        } else {
          return false;
        }
      }
      if (this.filterHighLight) {
        if (msg.highlight) {
          if (msg.from_uid === this.userInfo.uid) {
            return true;
          } else {
            if (
              (msg.role == 6 && !this.chatCheckRole) ||
              (msg.role == 5 && !this.chatCheckViewers) ||
              (msg.role == 7 && !this.chatCheckGuest) ||
              (msg.role == 8 && !this.chatCheckAssiant)
            ) {
              return false;
            } else {
              return true;
            }
          }
        } else {
          return false;
        }
      }
      if (this.filterAllC) {
        if (msg.from_uid === this.userInfo.uid) {
          return true;
        } else {
          if (
            (msg.role == 6 && !this.chatCheckRole) ||
            (msg.role == 5 && !this.chatCheckViewers) ||
            (msg.role == 7 && !this.chatCheckGuest) ||
            (msg.role == 8 && !this.chatCheckAssiant)
          ) {
            return false;
          } else {
            return true;
          }
        }
      }
    },
    changeChat(index) {
      switch (index) {
        case 0:
          this.chatText = '全部聊天';
          this.filterAllC = true;
          this.filterMeC = false;
          this.filterHighLight = false;
          break;
        case 1:
          this.chatText = '只看我';
          this.filterMeC = true;
          this.filterHighLight = false;
          this.filterAllC = false;
          break;
        case 2:
          this.chatText = '只看高亮';
          this.filterMeC = false;
          this.filterHighLight = true;
          this.filterAllC = false;
          break;
        default:
          break;
      }
      this.filterHistory();
      this.closeChatSelect();
    },
    openChatSelect() {
      this.openSelect = true;
    },
    closeChatSelect() {
      this.openSelect = false;
    },
    showMoreFun() {
      this.showMore = true;
    },
    closeMore() {
      this.showMore = false;
    },
    // 监听聊天审核窗口滚动
    handleAuditScroll() {
      let el = this.$refs.scrollerAuditList;

      el.onscroll = async () => {
        if (el.scrollHeight - el.offsetHeight == el.scrollTop) {
          //  向下加载审核消息
          this.auditLoadingType = 0;
          this.loadChatHistoryAuditList();
        }
        if (el.scrollTop == 0) {
          // 向上加载审核消息
          this.auditLoadingType = 1;
          this.auditLoading = true;
          this.getChatHistoryAuditListFunc();
        }
      };
    },
    loadChatHistoryAuditList() {
      console.log(this.auditListFilter[this.auditListFilter.length - 1]);
      let lastMgid =
        this.auditListFilter[this.auditListFilter.length - 1] &&
        this.auditListFilter[this.auditListFilter.length - 1].id;
      if (lastMgid) {
        this.auditLoading = true;
        this.noReadAudit = false;
        this.getChatHistoryAuditListFunc(lastMgid);
      }
    },
    // 监听滚动条
    handleScroll() {
      let el = this.$refs.scroller.$el;
      el.onscroll = () => {
        this.scrollBottomUpdateCalc();
      };
    },
    // 滚动到底部
    scrollBottom(force = false) {
      //console.log(this.calculateVal && !force, "this.calculateVal");
      if (this.show !== 0) return;
      if (this.calculateVal && !force) return;
      this.$nextTick(() => {
        if (!this.$refs.scroller) return;
        // this.$refs.scroller.scrollToBottom();
        this.$refs.scroller.$el.scrollTop =
          this.$refs.scroller.$el.scrollHeight - this.$refs.scroller.$el.offsetHeight - 5;
        this.calculateVal = 0;
        console.log('scrollBottom');
        this.oldscrollLocationVal = this.chatList.length;
        //滚动到底部置空
        //TODO 不在tab时也会触发滚动到底部
        this.atMsgIds = [];
        Bus.$emit('atMsgLength', 0);
        console.log(this.atMsgIds, 'this.atMsgIds 滚动到底部');
      });
    },
    // 记录滚动状态
    scrollBottomUpdateCalc() {
      // console.log('是否滚动');
      if (!this.$refs.scroller) return;
      let el = this.$refs.scroller.$el;
      this.scrollTop = el.scrollTop;
      // console.log(el.scrollHeight);
      // console.log(el.offsetHeight);
      // console.log(el.scrollHeight - el.offsetHeight, this.scrollTop + 50);
      if (el.scrollHeight - el.offsetHeight <= this.scrollTop + 50) {
        this.calculateVal = 0;
        this.oldscrollLocationVal = this.chatList.length;
        this.atMsgIds = []; //滚动到最后清空@数组
        Bus.$emit('atMsgLength', 0);
      } else {
        // console.log(this.chatList.length,'>50');
        //this.firstScrollTimer && clearInterval(this.firstScrollTimer);
        this.calculateVal = this.chatList.length;
      }
    },
    /**设置滚动条位置 */
    setScrolBarLocation() {
      if (!this.$refs.scroller) return;
      this.calculateVal = this.chatList.length;
      this.$refs.scroller.scrollToItem(0);
      this.scrollTop = 0;
    },
    init() {
      this.auditList = [];
      Bus.$on('systemMsg', (msg) => {
        let chat = {
          type: 'system',
          body: msg,
          top: 0,
          ts: new Date().getTime(),
          msgId: new Date().getTime(),
          filter: true
        };

        this.chatList.push(chat);
        this.filterListBack.push(chat);
        console.warn(msg, 'msg');
        this.scrollBottom();
      });
    },
    // （已审核）获取历史聊天消息
    getChatHistoryListFunc() {
      getChatHistoryList(
        {
          roomId: this.chatRoomId,
          topSize: 30,
          cmd: 1701,
          teamId: this.teamId != '0' ? this.teamId + ',0' : '' //默认传空给所有
        },
        this.liveToken
      ).then((res) => {
        if (res.code == 200) {
          if (res && res.data) {
            let chatList = res.data.sort(upSortcompare('time'));
            chatList.forEach((c) => {
              //console.log(c, "cccccccccccccc");
              if (c.content && c.content.event == 'giftEvent' && c.content.type == 'pay_success') {
                // this.chatList.push({
                //   type: "giftMsg",
                //   top: 0,
                //   body: c.content,
                //   ts: c.updateTime,
                // });
              } else if (c.content && c.content.event == 'redpacketEvent') {
                console.log('红包');
              } else {
                let chatMsg = Object.assign(c, c.content);
                // console.log(chatMsg, "chatMsg");
                chatMsg = Object.assign(chatMsg, {
                  type: 'normal',
                  msgId: chatMsg.mid,
                  ts: chatMsg.time,
                  filter: true
                });
                // console.log(chatMsg, "chatMsg.....");
                this.getCvMcRoomMessageChatRoom(chatMsg);
              }
            });
            setTimeout(() => {
              this.eachChatListSetingTop(true);
              this.analysisChatJudgeBannedToPostUser(false);
              this.eachChatListSetingHighlight(true);
            }, 1000);
          }
          this.scrollBottom();
        }
      });
    },
    // 获取未审核的聊天消息
    async getChatHistoryAuditListFunc(maxObjectId) {
      await getChatHistoryAuditList(
        { roomId: this.chatRoomId, topSize: 30, maxObjectId },
        this.liveToken
      ).then((res) => {
        if (res.code == 200) {
          this.auditLoading = false;
          if (!maxObjectId) {
            this.auditList = [];
            this.noReadAudit = false;
            if (this.$refs.scrollerAuditList) {
              this.$refs.scrollerAuditList.scrollTop = 0;
            }
          }
          res.data.forEach((c) => {
            let chatMsg = Object.assign(c, c.content, {
              type: 'normal',
              msgId: c.mid,
              ts: c.time,
              teamId: this.teamId != '0' ? this.teamId + ',0' : ''
            });
            this.auditList.push(Object.assign(this.chatData(chatMsg), { id: c.id }));
          });
        }
      });
    },
    getCvMcRoomMessage(msg) {
      //console.log(msg, "msg getCvMcRoomMessage")
      switch (msg.cmd) {
        case 7101: {
          let chatMsg = Object.assign(msg.requestData, msg.resDataInfo);
          //console.log(chatMsg, "7101 chatMsg 未变化");
          chatMsg = Object.assign(chatMsg, {
            msgId: msg.msgId,
            id: msg.id,
            cmd: msg.cmd,
            type: 'normal',
            filter: this.filterMsg(chatMsg)
          });
          console.log(chatMsg, '7101 chatMsg');
          console.log(this.userInfo.uid, 'uid current');

          if (chatMsg.picked_uid && chatMsg.picked_uid.includes(this.userInfo.uid)) {
            console.log('@@@@@', chatMsg.msgId);
            this.atMsgIds.push(chatMsg.msgId);
            Bus.$emit('atMsgLength', this.atMsgIds.length);
            console.log(this.atMsgIds, 'this.atMsgIds 添加');
          }
          this.getCvMcRoomMessageChatRoom(chatMsg);
          break;
        }
        case 7109: {
          this.handle_7109(msg, msg.cmd);
          break;
        }
        case 7119: {
          this.deleteChatmessageSuccessCallBack(msg.requestData.msgs, msg.requestData.all);
          break;
        }
        case 7113: {
          this.receiveAudiResult(msg);
          break;
        }
        case 7111: {
          this.receiveAudiMessage(msg);
          break;
        }
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData, msg.cmd, msg.id);
          break;
        }
        case 4123: {
          let usersChange = msg.requestData.user;
          console.log(usersChange, '4123');
          usersChange.forEach((item) => {
            if (item.uid === this.userInfo.uid) {
              this.changeName = item.name;
            }
          });
          break;
        }
        case 7123: {
          this.deleteChatmessageSuccessCallBack(msg.requestData.msgs);
          break;
        }
      }
    },
    getCvMcRoomControl(msg) {
      switch (msg.cmd) {
        case 6167: {
          this.monitorTopOrHighlight(msg);
          break;
        }
        case 6157: {
          // 清空聊天室成功回调在这个方法里
          this.getCvMcRoomControlChatRoom(msg);
          break;
        }
        case 6165: {
          for (let i = 0; i < msg.requestData.users.length; i++) {
            const uid = msg.requestData.users[i].uid,
              cid = msg.requestData.users[i].cid;
            this.bannedUserList.set(`${uid}_${cid}`, msg.requestData.users[i]);
          }
          sessionStorage.setItem('bannedUserList', JSON.stringify(msg.requestData.users));
          this.analysisChatJudgeBannedToPostUser(true);
          break;
        }
        case 4123:
          console.log('4123');
          break;
      }
    },
    /**实时获取聊天信息 */
    getCvMcRoomMessageChatRoom(chatMsg) {
      // return;
      //console.log(this.chatData(chatMsg), "this.chatData(chatMsg)");
      if (chatMsg.filter) {
        //this.chatList.push(this.chatData(chatMsg));
        this.tempChat.push(this.chatData(chatMsg));
        if (this.timeoutTimer === 0) {
          this.timeoutTimer = setTimeout(() => {
            if (this.tempChat.length > 0) {
              this.chatList = this.chatList.concat(this.tempChat);
              this.tempChat = [];
              this.scrollBottom();
            }
            this.timeoutTimer = 0;
          }, 300);
        }
      }
      this.filterListBack.push(this.chatData(chatMsg));
    },
    /**接收到聊天消息删除成功回调 */
    deleteChatmessageSuccessCallBack(delMsgs, isAll) {
      delMsgs.forEach((d) => {
        if (isAll != 1) {
          let findIndex = this.chatList.findIndex((info) => {
            return info.msgId == d.id;
          });
          if (findIndex != -1) {
            if (this.unreadNum && this.chatList.length - findIndex > this.unreadNum) {
              this.oldscrollLocationVal -= 1;
            }
            this.chatList.splice(findIndex, 1);
          }
          let findFilterIndex = this.filterListBack.findIndex((info) => {
            return info.msgId == d.id;
          });
          if (findFilterIndex != -1) {
            if (this.unreadNum && this.filterListBack.length - findFilterIndex > this.unreadNum) {
              this.oldscrollLocationVal -= 1;
            }
            this.filterListBack.splice(findFilterIndex, 1);
          }
          /**删掉记录的msg Id */
          for (let j = 0; j < this.atMsgIds.length; j++) {
            if (this.atMsgIds[j] == d.id) {
              this.atMsgIds.splice(j, 1);
              j--;
            }
          }
          Bus.$emit('atMsgLength', this.atMsgIds.length);
          console.log(this.atMsgIds, 'this.atMsgIds');
        } else {
          for (let i = 0; i < this.chatList.length; i++) {
            if (this.chatList[i].uid == d.from_uid) {
              this.chatList.splice(i, 1);
              i--;
            }
          }
          for (let i = 0; i < this.filterListBack.length; i++) {
            if (this.filterListBack[i].uid == d.from_uid) {
              this.filterListBack.splice(i, 1);
              i--;
            }
          }
          //全部删除时置空
          this.atMsgIds = [];
          Bus.$emit('atMsgLength', 0);
          console.log(this.atMsgIds, 'this.atMsgIds quanbu');
        }
      });
    },
    /* 转化数据 */
    chatData(chatMsg) {
      this.execLink(chatMsg);
      // console.log(chatMsg, ".....");
      // console.log(chatContent, "chatContent");
      for (let k in chatContent) {
        if (typeof chatContent[k] === 'boolean') {
          chatContent[k] = false;
        } else if (typeof chatContent[k] === 'number') {
          chatContent[k] = 0;
        } else {
          chatContent[k] = null;
        }
        if (k in chatMsg && k != 'body' && k != 'ts') {
          chatContent[k] = chatMsg[k];
        } else if (k == 'ucid') {
          chatContent[k] = chatMsg['from_cid'];
        } else if (k == 'uid') {
          chatContent[k] = chatMsg['from_uid'];
        } else if (k == 'body') {
          chatContent[k] = this.chatListHandle(chatMsg[k]);
        } else if (k == 'ts' && typeof chatMsg[k] == 'string') {
          chatContent[k] = Number(chatMsg[k]);
        } else if (k == 'ts' && typeof chatMsg[k] != 'string') {
          chatContent[k] = chatMsg[k];
        }
      }
      //console.log(JSON.parse(JSON.stringify(chatContent)),"dddddddddddddddddddd");
      return JSON.parse(JSON.stringify(chatContent));
    },
    execLink(chatMsg) {
      if (!chatMsg.imgState) {
        chatMsg.body = chatMsg.body.replace(/https?:\/\/(.*)/g, (url) => {
          return `<a class="cla-system-link" href="${url}" target="_blank">${url}</a>`;
        });
      }
    },
    /**
     * 处理获取的聊天记录的内容（处理表情包显示）
     * //TODO 此正则只能匹配【1F601之后有1-4位的数字】的表情包，后续如果多于4位需要优化
     */
    chatListHandle(chatData) {
      // console.log(chatData, "chatData");
      if (!chatData) return;
      let reg = RegExp('\\[1F60\\d{1,4}\\]', 'g');
      //console.log(reg.test(chatData), "regMatch");
      if (reg.test(chatData)) {
        emojiList.forEach((item) => {
          let rules = new RegExp(`\\[${item.codes}\\]`, 'g');
          let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
          chatData = chatData.replace(
            rules,
            `<img codes='${item.codes}' src='${_imgNameUrl}' class='chatEditSpan'/>`
          );
        });
      }
      return chatData;
    },
    /**
     * 处理粘贴事件
     */
    handlePaste(event) {
      event.preventDefault();
      // // 获取粘贴板上的HTML数据
      let htmlData = (event.clipboardData || window.clipboardData).getData('text/html');
      let htmlText = (event.clipboardData || window.clipboardData).getData('text/plain');
      console.log(htmlData, 'htmlData');
      console.log(htmlText, 'htmlText');
      if (htmlData && htmlData.trim()) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlData.trim(), 'text/html');
        console.log('html');
        if (this.parseBody(doc.body) !== '') {
          event.target.innerHTML += this.parseBody(doc.body);
        }
      }
      if (htmlText && htmlText.trim()) {
        console.log('text');
        event.target.innerHTML += htmlText.trim();
      }

      this.keepLastIndex(event.target);
      this.changeText();
    },
    checkForAtSign() {
      let selection = window.getSelection();
      let range = selection.getRangeAt(0);
      let textBeforeCursor = range.startContainer.textContent.substring(0, range.startOffset);
      // console.log(textBeforeCursor, "textBeforeCursor");
      let popupBox = document.getElementById('listContent');
      this.position = {
        range: range,
        selection: selection
      };
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        let lastWord = this.getLastWord(textBeforeCursor);
        //this.atLength = /@(.*)/.length || 1;
        if (lastWord.includes('@')) {
          let match = lastWord.match(/@(.*)/);
          console.log(match, 'math...');

          if (match && match[0]) {
            console.log('特定字符后的字符数是：' + match[0].length);
            this.atLength = match[0].length;
          }
          this.allAtList = [...this.JoinedList, ...this.audience];
          let searchTerm = lastWord.split('@')[1].toLowerCase();
          console.log(this.allAtList, 'this.allAtList');
          // console.log(searchTerm, "searchTerm")
          this.filterAtList = this.allAtList.filter(
            (item) =>
              item.uid !== this.userInfo.uid &&
              ((item.name && item.name.toLowerCase().indexOf(searchTerm) !== -1) ||
                (item.nickName && item.nickName.toLowerCase().indexOf(searchTerm) !== -1))
          );
          // console.log(this.filterAtList, "this.filterAtList")
          this.filterAtList = this.filterAtList.slice(0, 5);
          this.atList = true;
          setTimeout(() => {
            this.showPopupBox(popupBox);
          }, 0);
        } else {
          if (lastWord == '') {
            let words = textBeforeCursor.split(' ');
            let result = words
              .filter((word) => word.includes('@'))
              .map((word) => word.split('@')[1]);
            let filterUser = this.allAtList.filter(
              (user) =>
                (user.name && user.name.toLowerCase().indexOf(result) !== -1) ||
                (user.nickName && user.nickName.toLowerCase().indexOf(result) !== -1)
            );
            if (filterUser.length > 0) {
              this.pickedId.push(filterUser[0].uid);
            } else {
              this.pickedId = [];
            }
          }
          this.filterAtList = [];
          this.atList = false;
          popupBox.style.opacity = '0';
        }
      }, 300);
    },
    getLastWord(inputValue) {
      let words = inputValue.replace(/<[^>]*>?/gm, '').split(' ');
      return words[words.length - 1];
    },
    getCaretCoordinates(element) {
      let selection = window.getSelection();
      // console.log(selection, "selection");
      let range = selection.getRangeAt(0);
      // console.log(range, "range");
      let elementRect = element.getBoundingClientRect();
      // console.log(elementRect, "elementRect");

      let rect = range.getBoundingClientRect();
      // console.log(rect, "rect");
      return {
        top: rect.top - elementRect.top,
        left: rect.left - elementRect.left
      };
    },
    showPopupBox(popupBox) {
      //let popupBox = document.getElementById("listContent")
      let caretCoordinates = this.getCaretCoordinates(this.$refs.chatMessageRef);

      let rect = popupBox.getBoundingClientRect();
      let width = rect.width;
      let height = rect.height;

      // console.log(caretCoordinates, "caretCoordinates");
      // console.log(width, "width");
      // console.log(height, "height");
      popupBox.style.left = caretCoordinates.left - width / 2 + 'px';
      popupBox.style.top = caretCoordinates.top - height + 'px';
      popupBox.style.opacity = '1';
    },
    selectUser(user, event) {
      console.log(user, 'user');
      if (user.name) {
        this.pickedName = '@' + user.name;
      }
      if (user.nickName) {
        this.pickedName = '@' + user.nickName;
      }

      this.pickedId.push(user.uid ? user.uid : user.userId);
      this.replaceLastWord();
      if (event) {
        event.preventDefault();
      }
    },
    replaceLastWord() {
      let editableDiv = this.$refs.chatMessageRef;
      let inputValue = this.pickedName + ' ';
      console.log(inputValue, 'inputValue');
      // 获取当前文本光标的位置。
      const { selection, range } = this.position;
      console.log(selection, 'selection');
      console.log(range, 'range');
      let node = document.createTextNode(inputValue);
      let frag = document.createDocumentFragment();
      frag.appendChild(node);
      const textNode = range.startContainer;
      // console.log(this.getLastWord(textNode.textContent.substring(0, range.startOffset)), "textNode");
      range.setStart(textNode, range.endOffset - this.atLength);
      range.setEnd(textNode, range.endOffset);
      range.deleteContents();
      range.insertNode(frag);
      this.filterAtList = [];
      this.atList = false;
      let popupBox = document.getElementById('listContent');
      popupBox.style.opacity = '0';
      this.keepLastIndex(editableDiv);
      this.changeText();
    },
    parseBody(body) {
      let extractedContent = Array.from(body.childNodes)
        .map((node) => {
          if (node.nodeType === 1 && node.tagName.toLowerCase() === 'img') {
            // 保留 img 元素
            return node.outerHTML;
          } else if (node.nodeType === 3) {
            // 提取文本节点的文本内容
            return node.nodeValue;
          } else {
            // 处理其他元素，如果需要的话
            return '';
          }
        })
        .join('');
      console.log(extractedContent, 'extractedContent');
      return extractedContent;
    },
    /**
     * 跳转到@位置
     */
    clickToPosition() {
      // console.log(this.oldscrollLocationVal, "oldscrollLocationVal");
      // console.log(this.chatList, "chatList")
      // console.log(this.atMsgIds, "atMsgIds")
      let positionIndex = 0;
      this.chatList.forEach((item, index) => {
        if (item.msgId === this.atMsgIds[0]) {
          positionIndex = index;
        }
      });
      this.$refs.scroller.scrollToItem(positionIndex);
      this.oldscrollLocationVal = positionIndex;
      this.atMsgIds = [];
      Bus.$emit('atMsgLength', 0);
      console.log(this.atMsgIds, 'this.atMsgIds 跳转');
    },
    /**监听聊天内容输入 */
    changeText() {
      let _chatMessageRef = null;
      if (this.quoteMessage) {
        _chatMessageRef = this.$refs.replyChatMessageRef;
      } else {
        _chatMessageRef = this.$refs.chatMessageRef;
      }
      let count = this.getStrLen(_chatMessageRef.innerHTML);
      if (count > 140) {
        setTimeout(() => {
          _chatMessageRef.innerHTML = this.getStr(
            _chatMessageRef.innerHTML.replace(/<(?!img).*?>/g, '')
          );
          this.sendChatNumber = 140;
          this.keepLastIndex(_chatMessageRef);
        }, 0);
      } else {
        this.sendChatNumber = count;
      }
    },
    /**
     * 计算字数多少,包括img中含有codes属性及纯文本
     */
    getStrLen(htmlString) {
      // 使用DOMParser解析HTML字符串
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // 获取文本内容
      const plainText = doc.body.textContent || '';
      // 获取所有 img 标签
      const imgElements = doc.body.querySelectorAll('img');

      // 统计 img 标签数量
      const imgCount = imgElements.length;
      const plainTextCount = plainText.length;
      return plainTextCount + imgCount;
    },
    //替换html为text包含自定义表情
    getStrWithCodes(htmlString) {
      // 使用 DOMParser 解析 HTML 字符串
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // 获取所有 img 标签
      const imgElements = doc.body.querySelectorAll('img');

      // 遍历 img 标签，替换为 [codes] 形式
      imgElements.forEach((img) => {
        const codes = img.getAttribute('codes');
        let replacement = `[图片]`;
        if (codes) {
          replacement = `[${codes}]`;
        }
        img.outerHTML = replacement;
      });

      // 获取修改后的文本内容
      const modifiedText = doc.body.textContent || '';
      return modifiedText;
    },

    getStr(str) {
      const reg = /((<[\s]*img.*?src=?(.*?)?\s.*?>)|[\d\D]){0,140}/gi;
      return reg.exec(str)[0];
    },
    // 光标移至最后
    keepLastIndex(obj) {
      obj.focus();
      document.execCommand('selectAll', false, null);
      document.getSelection().collapseToEnd();
    },
    controlMaxLength(e) {
      const ev = e || window.event;
      // 如果是回车
      if (ev.keyCode == 13) {
        if (this.filterAtList.length < 1) {
          this.releaseFun();
        } else {
          this.selectUser(this.filterAtList[this.atIndex]);
        }
        ev.preventDefault();
        return false;
      }
    },
    /**表情选择 */
    emojiClick(item) {
      let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
      const Img = `<img codes="${item.codes}" src="${_imgNameUrl}" class="chatEditSpan"/>`;
      let obj = null;
      if (this.quoteMessage) {
        obj = this.$refs.replyChatMessageRef;
      } else {
        obj = this.$refs.chatMessageRef;
      }
      let range, node;
      if (!obj.hasfocus) {
        obj.focus();
      }
      if (window.getSelection && window.getSelection().getRangeAt) {
        range = window.getSelection().getRangeAt(0);
        range.collapse(false);
        node = range.createContextualFragment(Img);
        let c = node.lastChild;
        range.insertNode(node);
        if (c) {
          range.setEndAfter(c);
          range.setStartAfter(c);
        }
        let j = window.getSelection();
        j.removeAllRanges();
        j.addRange(range);
      } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().pasteHTML(Img);
      }
      this.changeText(true);
    },
    emojiUrl(item) {
      return require(`@/assets/emoji/${item.imgName}`);
    },
    parseToDOM(str) {
      // var div = document.createElement("div");
      // if (typeof str == "string") div.innerHTML = str;
      // return div.childNodes;
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, 'text/html');
      return Array.from(doc.body.childNodes);
    },

    /**发送聊天信息 */
    releaseFun() {
      let _chatMessageRef = null;
      if (this.quoteMessage) {
        _chatMessageRef = this.$refs.replyChatMessageRef;
      } else {
        _chatMessageRef = this.$refs.chatMessageRef;
      }
      let head = {
        cmd: 1701,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      //this.getStrLen(_chatMessageRef.innerHTML);
      // let mssageVal = _chatMessageRef.innerHTML
      //   .replace(/<img[^>]*>/gi, (matchVal) => {
      //     // let codes = matchVal.match(codesRules);
      //     let codes = this.parseToDOM(matchVal)[0].getAttribute("codes");
      //     return `[${codes}]`;
      //   })
      //   .replace(/&nbsp;/g, " ")
      //   .trim();
      let mssageVal = this.getStrWithCodes(_chatMessageRef.innerHTML);
      if (!mssageVal) return;
      console.log(mssageVal, '要发送的值');

      //console.log(this.changeName,"changeNamechangeName")
      let Body = {
        role: this.role == 3 ? 6 : 7,
        name: this.userInfo.name,
        body: mssageVal,
        type: 'normal',
        team_id: this.teamId,
        groupSerialNumbe: this.groupOrder,
        picked_uid: [...new Set(this.pickedId)]
      };
      if (this.quoteMessage) {
        this.quoteMessage.chatContent =
          this.quoteMessage.chatContent &&
          this.quoteMessage.chatContent
            .replace(/<img[^>]*>/gi, (matchVal) => {
              let codes = this.parseToDOM(matchVal)[0].getAttribute("codes");
              return `[${codes}]`;
            })
            .replace(/&nbsp;/g, " ");
        //this.getStrWithCodes(this.quoteMessage.chatContent);
        Body['quote'] = { ...this.quoteMessage };
      }
      this.ccWebsocketClient.customizeSendMsg(head, Body);
      this.quoteMessage = null;
      _chatMessageRef.innerHTML = '';
      this.sendChatNumber = 0;
      this.openReply = false;
      this.pickedId = [];
      this.scrollBottom(true);
      this.atList = false;
    },
    /** 生成一个通信32位id */
    getChatHeadId() {
      return `${uuid(15, 62)}${new Date().getTime()}`;
    },
    /**监听高亮或者置顶信息 */
    monitorTopOrHighlight(msg) {
      let _requestData = msg.requestData;
      if (_requestData.extra) {
        // 置顶消息处理
        if (_requestData.extra.top) {
          // 保存置顶消息
          // 置顶or取消置顶
          let isTop = Object.values(_requestData.extra.top).find((info) => {
            return info;
          });
          this.saveTopObj = Object.keys(_requestData.extra.top).reverse();
          this.eachChatListSetingTop(isTop);
          //置顶@消息，删除保存的id
          // if(this.atMsgIds.length > 0){
          //   let myMap = new Map(Object.entries(_requestData.extra.top));
          //   for(let j = 0; j < this.atMsgIds.length; j++) {
          //   if (myMap.has(this.atMsgIds[j])) {
          //     this.atMsgIds.splice(j, 1);
          //     j--;
          //   }
          // }
          // Bus.$emit("atMsgLength", this.atMsgIds.length)
          // console.log(this.atMsgIds, "this.atMsgIds 置顶后")
          //}
        }
        // 高亮消息处理
        if (_requestData.extra.highlight) {
          this.saveHighlightObj = Object.keys(_requestData.extra.highlight);
          let isHighlight = Object.values(_requestData.extra.highlight).find((info) => {
            return info;
          });
          this.eachChatListSetingHighlight(isHighlight);
        }
      }
    },
    eachChatListSetingTop(isTop) {
      let topMsgLength = 0;
      if (this.saveTopObj) {
        topMsgLength = this.saveTopObj.length;
      }
      if (this.chatList.length == 0 || topMsgLength == 0) return;
      this.saveTopObj.forEach((mid) => {
        let findInChatInfo = this.chatList.find((msg) => {
          return msg.msgId == mid;
        });
        let findInBack = this.filterListBack.find((msg) => {
          return msg.msgId == mid;
        });
        if (findInChatInfo) {
          if (isTop) {
            let maxTop = this.getSortMax();
            findInChatInfo.top = maxTop + 1;
          } else {
            findInChatInfo.top = 0;
          }
        }
        if (findInBack) {
          if (isTop) {
            let maxTop = this.getSortMax();
            findInBack.top = maxTop + 1;
          } else {
            findInBack.top = 0;
          }
        }
      });
      this.chatList = this.chatList.sort(upSortcompare('ts'));
      this.chatList = this.chatList.sort(downSortcompare('top'));
      this.filterListBack = this.filterListBack.sort(upSortcompare('ts'));
      this.filterListBack = this.filterListBack.sort(downSortcompare('top'));
      // this.scrollBottom();
    },
    eachChatListSetingHighlight(highlight) {
      if (this.saveHighlightObj.length == 0 || this.chatList.length == 0) return;
      this.saveHighlightObj.forEach((mid) => {
        let findInChatInfo = this.chatList.find((msg) => {
          return msg.msgId == mid;
        });
        if (findInChatInfo) {
          findInChatInfo.highlight = !!highlight;
        }
        let findInChatInfoBack = this.filterListBack.find((msg) => {
          return msg.msgId == mid;
        });
        if (findInChatInfoBack) {
          findInChatInfoBack.highlight = !!highlight;
        }
      });
    },
    getSortMax() {
      return Math.max.apply(
        Math,
        this.chatList.map((item) => {
          return item.top;
        })
      );
    },
    operationFunc(item) {
      item.handle = true;
    },
    mouseenter(index, item) {
      document.getElementById(`chat-more${index}`).style.display = 'inline-block';
      item.handle = true;
      if (item.hideTimer) {
        clearTimeout(item.hideTimer);
      }
    },
    /** 用户操作处理:置顶、高亮 */
    handleFun(code, chatItem) {
      chatItem.handle = false;
      switch (code) {
        case 'kickOut': {
          /**踢出 */
          this.kickOutFunc(chatItem);
          break;
        }
        case 'bannedToPost': {
          /**禁言用户 */
          this.bannedToPostFunc(chatItem);
          break;
        }
        case 'highlight': {
          //高亮
          this.setingOrCancelHighlight(chatItem);
          break;
        }
        case 'top': {
          //置顶
          this.setingOrCancelTop(chatItem);
          break;
        }
        case 'delte': {
          //删除
          this.delteUserChatMessage(chatItem, false);
          break;
        }
        case 'delteAll': {
          //删除
          this.delteUserChatMessage(chatItem, true);
          break;
        }
        case 'withdraw': {
          // 撤回自己
          this.delteUserChatMessage(chatItem, false);
          break;
        }
      }
    },
    delayHideHandle(item) {
      item.hideTimer = setTimeout(() => {
        item.handle = false;
      }, 300);
    },
    /** 踢出用户接口 */
    async kickOutFunc(chatItem) {
      this.ccWebsocketClient.kickoutCvMcRoom(this.chatRoomId, [
        { cid: chatItem.ucid, uid: chatItem.uid, dev: chatItem.from_dev }
      ]);
      await winkleUser(
        {
          webcastId: this.liveId,
          userId: chatItem.uid
        },
        this.liveToken
      );
    },
    /**禁言用户 */
    bannedToPostFunc(chatItem) {
      this.ccWebsocketClient.setCvMcRoomUserAttr(
        this.chatRoomId,
        [
          {
            cid: chatItem.ucid,
            uid: chatItem.uid,
            dev: chatItem.from_dev,
            silence: chatItem.bannedToPost ? 0 : 1
          }
        ],
        'cloud_webcast'
      );
    },
    //
    bannedToPostAndDelete(item) {
      // 禁言用户
      this.bannedToPostFunc(item);
      this.checkUserAudit(item);
    },
    //高亮
    setingOrCancelHighlight(chatItem) {
      let extraMessage = {
        highlight: {}
      };
      if (!chatItem.highlight) {
        extraMessage.highlight[`${chatItem.msgId}`] = 'open';
      } else {
        extraMessage.highlight[`${chatItem.msgId}`] = null;
      }
      this.sendExtraMessage(extraMessage);
    },
    //置顶
    setingOrCancelTop(chatItem) {
      let extraMessage = {
        top: {}
      };
      // 取消置顶
      if (chatItem.top != 0) {
        extraMessage.top[`${chatItem.msgId}`] = null;
      } else {
        // 置顶
        let obj = {
          open: true
        };
        extraMessage.top[`${chatItem.msgId}`] = JSON.stringify(obj);
      }
      this.sendExtraMessage(extraMessage);
    },
    /** 删除用户某条聊天记录*/
    delteUserChatMessage(chatItem, isAll) {
      let head = {
        cmd: 1715,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      let Body = {
        msgs: [
          {
            from_cid: chatItem.ucid,
            from_uid: chatItem.uid,
            from_dev: chatItem.from_dev,
            id: chatItem.msgId
          }
        ]
      };
      if (isAll) {
        Body.all = 1;
      }
      this.ccWebsocketClient.customizeSendMsg(head, Body);
    },
    /**回复按钮回调 */
    replyFun(item) {
      this.quoteMessage = {
        name: item.name,
        ucid: item.ucid,
        uid: item.uid,
        imgState: item.imgState,
        imgUrl: item.imgUrl,
        chatContent: item.body,
        from_dev: item.from_dev,
        msgId: item.msgId,
        filter: true
      };
      //打开回复的弹框
      this.openReply = true;
    },
    // 关闭回复
    closeReply() {
      this.quoteMessage = null;
      if (this.$refs.replyChatMessageRef) {
        this.$refs.replyChatMessageRef.innerHTML = '';
      }
      this.sendChatNumber = 0;
      this.openReply = false;
    },
    /**cc socket发送信息 */
    sendExtraMessage(extraMessage) {
      let head = {
        cmd: 1627,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      let boday = {
        extra: extraMessage
      };
      this.ccWebsocketClient.customizeSendMsg(head, boday);
    },
    analysisChatJudgeBannedToPostUser() {
      let bannedUserList = Array.from(this.bannedUserList.values());
      if (this.chatList.length == 0 || bannedUserList.length == 0) return;
      for (let i = 0; i < bannedUserList.length; i++) {
        let uid = bannedUserList[i].uid;
        //  const status =
        //       this.bannedUserList[i].silence == 1 ? "已被禁言" : "已被解除禁言";
        //     Bus.$emit("systemMsg", `${this.chatList[j].name}${status}`);
        //     this.$message.success(`${this.chatList[j].name}${status}`);
        // const curSilenceUser = this.chatList.find((i) => {
        //   return i.uid == uid;
        // });
        // if (curSilenceUser) {
        //   const status =
        //     bannedUserList[i].silence == 1
        //       ? this.$t("chatroom.已被禁言")
        //       : this.$t("chatroom.已被解除禁言");
        //   Bus.$emit("systemMsg", {
        //     name: curSilenceUser.name,
        //     text: status,
        //   });
        //   this.$message.success(`${curSilenceUser.name}${status}`);
        // }
        for (let j = 0; j < this.chatList.length; j++) {
          if (this.chatList[j].uid == uid) {
            this.chatList[j].bannedToPost = bannedUserList[i].silence == 1 ? true : false;
          }
        }
      }
    },
    /**处理全部禁言状态 */
    allBannedToPostChange(state) {
      let setVal = {};
      setVal.silence = 0;
      if (state) {
        setVal.silence = 1;
      }
      this.setCvMcRoomAttr(setVal);
    },
    getCvMcRoomControlChatRoom(res) {
      let _requestData = res.requestData;
      let _attr = _requestData.attr;
      this.joinAuditTime++;
      this.initAuditStatus = this.joinAuditTime == 1 && _attr.audit === 1 ? true : false; // //首次进入,文字审核开启，最小化显示
      if (
        _attr.msg_clean_time &&
        this.groupJurisdiction.msg_clean_time !== -1 &&
        this.groupJurisdiction.msg_clean_time !== _attr.msg_clean_time
      ) {
        this.emptyChatVisible = false;
        this.moreMessageState = false;
        this.chatList = [];
        this.scrollBottom();
      } else {
        this.groupJurisdiction = { ...this.groupJurisdiction, ..._attr };

        // if (_attr.silence != undefined) {
        //   this.releaseState = _attr.silence === 1;
        // }

        if (_attr.audit != undefined) {
          this.chatCheckState = _attr.audit === 1;
          // if (this.chatCheckState) {
          //   this.showAsideAudit = true;
          // }
        }
        this.chatRoomCheckPower(_attr, res.cmd);
      }
    },
    /**判断当前聊天室审核权限 */
    chatRoomCheckPower(attrObj) {
      //silence不存在就是聊天审核
      if (attrObj.audit === 1) {
        this.chatCheckText = this.$t('chatroom.审核开启');
        if (this.groupJurisdiction.auto_audit_time > 0) {
          this.chatCheckText = this.$t('chatroom.自动审核');
        } else {
          this.chatCheckText = this.$t('chatroom.人工审核');
        }
      } else if (attrObj.audit === 0) {
        this.chatCheckText = this.$t('chatroom.审核关闭');
      }
      if (attrObj.auto_audit_time != undefined && attrObj.audit == undefined) {
        if (attrObj.auto_audit_time > 0) {
          this.chatCheckText = this.$t('chatroom.自动审核');
        } else {
          this.chatCheckText = this.$t('chatroom.人工审核');
        }
      }
      this.chatControl(attrObj);
      if (this.calculateVal === 0) {
        this.scrollBottom();
      }
    },
    /**
     * 聊天开启禁止
     */
    chatControl(attrObj) {
      console.log(this.allBannedToPost, 'allBannedToPost');
      if (attrObj.silence === 1) {
        if (!this.firstInit) {
          this.$message.success(this.$t('chatroom.直播间聊天已禁止'));
        }
        Bus.$emit('systemMsg', {
          text: '直播间聊天已禁止'
        });
      } else if (attrObj.silence === 0) {
        if (!this.firstInit) {
          this.$message.success(this.$t('chatroom.直播间聊天已开放'));
        }

        Bus.$emit('systemMsg', {
          text: '直播间聊天已开放'
        });
      }
      if (attrObj.silence != undefined) {
        this.allBannedToPost = attrObj.silence === 1 ? true : false;
      }
    },
    /** 设置群权限 */
    setCvMcRoomAttr(setVal) {
      this.ccWebsocketClient.setCvMcRoomAttr(this.chatRoomId, setVal, 'cloud_webcast');
    },
    /** 清空聊天室 */
    emptyChatFunc() {
      this.chatList = [];
      this.filterListBack = [];
      this.emptyChatVisible = false;
    },
    /**下载聊天记录 */
    downloadExcelFunc() {
      let params = {
        teamId: this.teamId != '0' ? this.teamId + ',0' : ''
      };
      downloadChat(this.liveId, params)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.$t('chatroom.聊天记录') + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t('chatroom.文件下载失败'));
        });
    },
    filterContent(content, imgState) {
      if (!this.messageFilterFlag) {
        return true;
      }
      if (imgState) {
        return false;
      }
      let contentHtml = null;
      if (content) {
        contentHtml = content && content.replace(/<img[^>]*>/gi, 'a');
        contentHtml = content && content.replace(/<br[^>]*>/gi, '');
      }
      return this.contentShow(contentHtml);
    },
    contentShow(contentHtml) {
      if (contentHtml && contentHtml.length >= 10) {
        return true;
      }
      return false;
    },
    /**
     *审核函数
     */
    checkFunc(item, auditStatus) {
      let head = {
        cmd: 1713,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      let body = {
        msgs: [
          {
            from_cid: item.ucid,
            from_uid: item.uid,
            from_dev: item.from_dev,
            id: item.msgId,
            team_id: this.teamId
          }
        ],
        audit_status: auditStatus
      };
      this.ccWebsocketClient.customizeSendMsg(head, body);
    },
    // 通过全部审核
    allCheckSuccessFunc(status) {
      let head = {
        cmd: 1713,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      let boday = {
        audit_status: status,
        all: 1,
        team_id: this.teamId
      };
      this.ccWebsocketClient.customizeSendMsg(head, boday);
      if (status == 0) {
        this.chatCheckShow = false;
      }
    },
    // 检测某个人的审核消息
    checkUserAudit(item) {
      let head = {
        cmd: 1713,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId
      };
      let body = {
        msgs: [
          {
            from_cid: item.ucid,
            from_uid: item.uid,
            from_dev: item.from_dev,
            team_id: this.teamId
          }
        ],
        audit_status: 0
      };
      this.ccWebsocketClient.customizeSendMsg(head, body);
    },
    /**接收审核结果 */
    async receiveAudiResult(msg) {
      let id = null;
      if (msg.requestData && msg.requestData.msgs.length != 0) {
        id = msg.requestData.msgs[0].id;
      }
      let { audit_status, finished } = msg.requestData;
      // 2. 按用户批量审核，msgs为from_cid,from_uid,fro_dev数组，
      //3. 全部不通过，audit_status==0，finished==1      这两种情况重新查列表
      if (!id || (audit_status == 0 && finished == 1)) {
        //如果
        this.auditList = [];

        await this.getChatHistoryAuditListFunc('');

        return;
      }
      // 1. 按消息批量审核， msgs为消息id数组，   直接删除
      msg.requestData.msgs.forEach((val) => {
        const index = this.auditList.findIndex((info) => {
          return info.msgId == val.id;
        });
        if (index != -1) {
          this.auditList.splice(index, 1);
        }
      });
      if (audit_status == 1) {
        //全部通过
        await this.getChatHistoryAuditListFunc('');
      }
    },
    /**接收审核信息 */
    receiveAudiMessage(msg) {
      if (this.$refs.scrollerAuditList && this.$refs.scrollerAuditList.scrollHeight) {
        var isNotScroll =
          this.$refs.scrollerAuditList.scrollHeight == this.$refs.scrollerAuditList.offsetHeight;
      }
      if (isNotScroll) {
        msg.requestData.msgs.forEach((val) => {
          let chatMsg = Object.assign(val, val.content, {
            msgId: val.content.msgId || val.id,
            id: val.id,
            cmd: val.cmd,
            type: 'normal',
            ts: val.content.sendTime,
            team_id: this.teamId
          });
          this.auditList.unshift(Object.assign(this.chatData(chatMsg), { id: val._id }));
        });
      }
      this.auditMsgTips = !this.chatCheckShow;
      this.noReadAudit =
        this.chatCheckShow &&
        !isNotScroll &&
        this.$refs.scrollerAuditList &&
        this.$refs.scrollerAuditList.scrollTop == 0
          ? true
          : false;
    },
    //审核列表是否滚动到底部
    auditIsScrollBottom() {
      // return this.$refs.scrollerAuditList.scrollHeight - this.$refs.scrollerAuditList.offsetHeight == this.$refs.scrollerAuditList.scrollTop ? true : false
    },
    // 切换聊天审核状态
    changeChatCheckState(val) {
      if (this.auditList.length > 0) {
        console.log(this.auditList, '待审核消息');
      }
      if (val) {
        this.setCvMcRoomAttr({ audit: 1 });
      } else {
        this.setCvMcRoomAttr({ audit: 0 });
      }
    },
    /**文件上传成功 */
    uploadSuccess(res) {
      if (res.code === 0) {
        let head = {
          cmd: 1701,
          id: this.getChatHeadId(),
          room_id: this.chatRoomId
        };
        let Body = {
          role: this.role == 3 ? 6 : 7,
          name: this.userInfo.name,
          imgUrl: res.data[1],
          imgState: true
        };
        this.ccWebsocketClient.customizeSendMsg(head, Body);
      } else {
        this.$message.error(this.$t('chatroom.图片格式错误，请重新选取'));
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小超过2M，请重新选取');
      }
      return isLt2M;
    },
    // 敏感词
    handle_7109({ requestData, cmd }) {
      if (requestData.action == 'sensitive_word') {
        let chat = {
          type: 'warning',
          msg: `${this.$t('chatroom.您的聊天消息中包含有敏感词')}“${requestData.hit_words.join(
            '、'
          )}”`,
          ts: new Date().getTime(),
          cmd,
          top: 0,
          msgId: new Date().getTime(),
          filter: true
        };
        this.chatList.push(chat);
        this.filterListBack.push(chat);
        this.scrollBottom();
      }
    },
    disposeCustomMessage_7107(requestData, cmd, id) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'chatImagesStatus': {
            this.$store.commit('SET_CHAT_IMAGE', `${requestData.status}` === '0');
            break;
          }
          case 'giftEvent': {
            if (requestData.type == 'pay_success') {
              const payInfo = Object.assign({ cmd: cmd, id: id }, requestData);
              let chat = {
                type: 'giftMsg',
                top: 0,
                body: payInfo,
                ts: new Date().getTime(),
                msgId: new Date().getTime(),
                filter: true
              };
              this.chatList.push(chat);
              this.filterListBack.push(chat);
              this.scrollBottom();
            }
            break;
          }
          case 'redpacketEvent': {
            if (requestData.type == 'draw') {
              if (requestData.drawDetailList) {
                requestData.drawDetailList.forEach((info) => {
                  const drawinfo = Object.assign({ cmd: cmd, id: id }, info);
                  let chat = {
                    type: 'redpacketMsg',
                    top: 0,
                    body: drawinfo,
                    ts: new Date().getTime(),
                    msgId: `${info.userId}${new Date().getTime()}`,
                    filter: true
                  };
                  this.chatList.push(chat);
                  this.filterListBack.push(chat);
                });
                console.log(this.chatList);
              }
            }
            break;
          }
        }
      }
    },
    openRedPacketDetail(item) {
      Bus.$emit('idList', Object.assign(item, { id: item.redpacketId }));
      this.$store.commit('SET_SHOW_RED_PACKEY_DETAIL', true);
    },
    resizeScroller() {
      console.log('大小改变');
    }
  }
};
</script>

<style lang="scss">
.chat-box {
  height: calc(100% - 59px);

  .box-con {
    height: calc(100% - 129px);
    overflow-y: hidden;

    .chat-list {
      height: 100%;
      overflow: hidden;
      position: relative;

      .chat-list-right,
      .chat-list-left {
        .chat-content {
          max-width: 210px;
        }
        > div {
          display: inline-block;
        }
        width: 100%;
        margin-bottom: 12px;
        position: relative;
        .chat-list-name {
          color: $grey5-color;
          font-weight: inherit;
          font-size: 12px;
          // display: flex;
          align-items: center;
        }

        .chat-list-img {
          max-width: 100%;
        }

        .chat-list-body {
          color: $white-color;
          padding: 7px 10px;
          word-wrap: break-word;
          word-break: normal;
          width: fit-content;
          max-width: 110px;
          text-align: left;
          font-size: 12px;
          margin-top: -2px;
          position: relative;
        }

        .chat-more {
          font-size: 12px;
          color: $bule-color;
          top: 20px;
          display: none !important;
          height: 30px;
          position: absolute;
          z-index: 10;
          margin-left: 10px;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          white-space: nowrap;
          line-height: 1;

          .chat-reply {
            margin-right: 10px;
            height: 100%;
            display: inline-flex;
            align-items: center;
          }

          .chat-more-list {
            width: 20px;
            display: inline-flex;
            align-items: center;
            overflow: hidden;
            position: relative;
            z-index: 1;
            vertical-align: top;
            height: 100%;

            img {
              filter: drop-shadow($bule-color 80px 0);
              -webkit-filter: drop-shadow($bule-color 80px 0);
              transform: translateX(-80px);
            }
          }
        }
      }

      .chat-list-right {
        float: right;
        text-align: right;

        .chat-content {
          float: right;
        }

        .chat-list-body {
          background-color: $bule-color;
          border-radius: 12px 0px 8px 12px;
          float: right;
          margin-right: 36px;
          padding-left: 18px;
        }

        .chat-content-img {
          background: none;
        }

        .chat-more {
          margin-right: 10px;
          left: 100%;
          left: -20px;
          transform: translate(-100%, -50%);
        }

        .chat-avatar {
          margin-left: 10px;
        }

        .chat-name {
          margin-left: 10px;
        }

        .chat-handle-list {
          right: 10px;
          // position: absolute;
        }
      }

      .chat-list-left {
        float: left;
        text-align: left;

        .chat-list-body {
          background-color: $purple5-color;
          border-radius: 0px 12px 12px 8px;
          margin-left: 38px;
          padding-right: 18px;
        }

        .chat-content-img {
          background: none;
        }

        .chat-more {
          position: absolute;
          margin-left: 10px;
        }

        .chat-list-name {
          display: flex;
        }

        .chat-avatar {
          margin-right: 10px;
        }

        .chat-name {
          margin-right: 10px;
        }

        // 57257 【主播角色转移】主播转移角色给嘉宾再自己升级为主播，聊天消息中第一条消息的更多的窗口显示异常。
        // .chat-handle-list {
        //   right: -80%;
        // }
      }

      .chat-list-right:hover .chat-more,
      .chat-list-left:hover .chat-more {
        display: inline-block !important;
      }

      .chat-list-right.showMore .chat-more,
      .chat-list-left.showMore .chat-more {
        display: inline-block !important;
      }

      .chat-highlight {
        color: $yellow-color !important;
      }

      .chat-list-topfirst {
        position: absolute;
        z-index: 2;
        background: #2d3052;
        right: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 7px 20px 7px 12px;
        box-sizing: border-box;

        .topfirst-btn {
          background: #ff595b;
          font-size: 12px;
          color: #fff;
          width: 40px;
          height: 20px;
          line-height: 20px;
          border-radius: 4px;
        }

        .topfirst-body {
          font-size: 12px;
          width: calc(100% - 50px);

          .topfirst-content {
            color: #fff;
            text-align: left;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;

            img {
              max-width: 70%;
            }
          }

          .topfirst-more {
            text-align: right;
            color: #3986ee;
          }
        }
      }
    }
  }

  .bottom-bar {
    height: 130px;

    .bottom-bar-handle {
      height: 30px;
      background: $purple5-color;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 7px 0 14px;

      .bottom-bar-control {
        .bottom-bar-switch {
          display: flex;
          justify-content: space-between;
          color: $white-color;
        }
      }

      .bottom-bar-control-name {
        color: $white-color;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .bottom-send-msg {
      height: 100px;
      padding: 0 9px;
      position: relative;

      .bottom-bar-handel {
        display: flex;
        justify-content: space-between;
        height: 36px;
        align-items: center;
        padding: 0px 5px;

        .bottom-bar-img {
          position: relative;

          img {
            display: inline-block;
            width: 20px;
            cursor: pointer;
            vertical-align: middle;
          }

          .mr10 {
            margin-right: 10px;
          }

          .bottom-bar-emoji:hover ~ .emoji-list {
            display: inline-block;
          }
        }

        .bottom-bar-btn {
          button {
            background-color: $bule-color;
            color: $white-color;
            border: none;
            border-radius: 6px;
          }
        }
      }
    }
  }

  .chatEditSpan {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    vertical-align: middle;
  }

  .chat-edit {
    cursor: text;
    overflow-x: hidden;
    overflow-y: auto;
    word-break: normal;
    outline: none;
    font-size: 12px;
    text-align: left;
    padding: 9px 5px 0;
    height: 54px;
    color: $white-color;
  }

  .chat-edit:empty::before {
    content: attr(placeholder);
    color: #acb2bf;
    font-size: 12px;
  }

  .emoji-list {
    display: none;
    width: 240px;
    position: absolute;
    bottom: 20px;
    text-align: left;
    background-color: #2d3052;
    border-radius: 6px;
    left: 0;
    padding: 6px;
    z-index: 600;

    li {
      display: inline-block;
      padding: 4px;
      border-radius: 2px;

      > img {
        margin: 0px 3px;
        display: inline-block;
        width: 20px;
      }
    }
  }

  .reply-name {
    margin-bottom: 20px;
    font-size: 12px;
    text-align: left;

    p {
      display: inline-block;
    }
  }

  .reply-img {
    width: 20px;
    display: inline-block;
    overflow: hidden;
    z-index: 1;
    height: 100%;
    margin-left: 5px;

    > img {
      filter: drop-shadow($bule-color 80px 0);
      -webkit-filter: drop-shadow($bule-color 80px 0);
      transform: translateX(-80px);
    }
  }

  .reply-img:hover .emoji-list {
    display: inline-block;
  }

  .reply-content {
    border: 1px solid #444767;
    text-align: left;

    .limitlength {
      float: right;
      margin-right: 5px;
      color: $grey3-color;
    }
  }

  .emoji-list:hover {
    display: inline-block;
  }

  .chat-audio-list {
    height: 100%;
    overflow-y: auto;

    li {
      padding: 16px 24px;
      text-align: left;
      border-bottom: 1px solid #2d3052;

      .chat-audio-header {
        margin-bottom: 10px;
      }

      .chat-audio-bottom {
        color: $grey3-color;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .system-body {
    line-height: 25px;
    color: #8a8f99;
    float: right;
    width: 100%;
    position: relative;
  }

  .chat-avatar {
    display: inline-block;
    vertical-align: middle;

    img {
      vertical-align: middle;
      border-radius: 14px;
      height: 28px;
    }
  }

  .chat-name {
    display: inline-block;
    max-width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    flex: 1;
    min-width: 0;
  }
}

.chat-quote-text {
  color: rgba($color: #fff, $alpha: 0.4);
  border-radius: 8px;
  float: right;
  margin: 0 36px;
  padding: 5px 8px;
  background: #333a64;
  font-size: 12px;
  margin-top: 7px;
  text-align: left;
  max-width: 180px;
}

.chat-quote-line {
  height: 1px;
  margin: 6px 0;
  background-color: rgba($color: #fff, $alpha: 0.2);
}

.quateContent {
  word-break: break-word;
  overflow: hidden;
  white-space: pre-wrap;
}

.tips {
  font-size: 12px;
  color: #8a8f99;
}

.chat_audit {
  min-width: 76px;
  height: 32px;
  background-color: $purple5-color;
  position: absolute;
  top: 220px;
  line-height: 32px;
  color: #fff;
  padding: 0px 5px;
  display: flex;
  justify-content: space-around;
  padding: 0px 4px;
  img {
    object-fit: contain;
    cursor: pointer;
  }
  .auditList-length {
    height: 6px;
    background: #ea494b;
    border-radius: 50%;
    margin: 6px 0px;
    width: 6px;
  }
  z-index: 500;
  cursor: pointer;
}

.giftmsg-body {
  position: relative;
  // padding: 2px 54px 2px 20px;
  // background-image: -webkit-gradient(
  //   linear,
  //   left top,
  //   right top,
  //   from(#006a88),
  //   to(#0a3068)
  // );
  position: relative;
  color: #fff;
  background-image: linear-gradient(90deg, #006a88, #0a3068);
  border-radius: 20px;
  height: 26px;
  margin: 5px auto;
  padding: 0px 15px;
  float: right;
  right: calc(100% - 225px);
  width: 180px;
  overflow: hidden;

  .giftmsg-body-name {
    max-width: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  span {
    display: inline-block;
    line-height: 26px;
  }

  img {
    height: 22px;
    vertical-align: middle;
    position: relative;
    top: 0px;
    margin-left: 5px;
  }
}

.redpacketmsg-body {
  width: 240px;
  height: 26px;
  background: #2a2f5c;
  border-radius: 4px;
  font-size: 12px;
  color: #8a8f99ff;
  line-height: 26px;
  margin: 10px 0px;

  img {
    vertical-align: middle;
    width: 15px;
    margin-right: 5px;
  }

  .redpacketmsg-redcolor {
    color: #f73e4aff;
  }

  .textHide {
    width: auto;
    max-width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
  }
}

.dialog-header {
  position: absolute;
  top: 15px;
  right: 20px;
  background: #212442;
  cursor: pointer;
}

.chat-item-top {
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.chat-role {
  color: #3986ee;
  margin-right: 6px;
  margin-left: 6px;
}

.chat-role-5 {
  color: #ffb528;
  margin-left: 6px;
  margin-right: 6px;
}

// .check-dialog{
//   margin: initial;
//     top: inherit;
//     bottom: 770px;
//     right: 410px;
//     overflow: inherit;
//     left: inherit;
// }
.check-dialog .el-dialog {
  margin: 0px;
  width: 454px;
  right: 300px;
  bottom: 0px;
  position: absolute;
  height: calc(100% - 40px);
  // right: calc((100% - 300px + 80px) / 2);
}

.chat-tool {
  display: flex;
  align-items: center;
}

.more-chat-tool {
  position: absolute;
  right: 5px;
  bottom: 140px;
  width: 114px;
  height: 113px;
  background: #222442;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  z-index: 2000;

  li {
    line-height: 35px;
  }
}

.chat-select {
  position: absolute;
  left: 30px;
  bottom: 140px;
  width: 114px;
  height: 113px;
  background: #222442;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  color: #fff;
  font-size: 12px;
  z-index: 1000;

  li {
    line-height: 35px;
    cursor: pointer;
  }
}

.mr12 {
  margin-right: 12px;
}
</style>
<style lang="scss">
.chat-list-right .kickOut .el-popover {
  position: absolute;
  left: -48px !important;
  top: -90px !important;
}

.chat-list-left .kickOut .el-popover {
  position: absolute;
  left: -48px !important;
  top: -90px !important;
}

.chat-handle-popover.el-popper {
  min-width: 96px;
  padding: 0 12px;
  margin-top: 0;
}

.chat-handle-list {
  z-index: 1000;
  text-align: left;
  color: $white-color;
  padding: 6px 0;
  background-color: $purple6-color;
  border-radius: 6px;
  font-size: 12px;
  position: relative;

  li {
    line-height: 30px;
    position: relative;
    white-space: nowrap;
    cursor: pointer;

    span {
      display: block;
    }
  }
}

.dynamicScroller {
  height: 100%;
  padding: 0px 14px;
}

.chat-unread {
  position: absolute;
  z-index: 999;
  height: 24px;
  line-height: 24px;
  left: 50%;
  bottom: 10px;
  font-size: 12px;
  color: #fff;
  transform: translateX(-50%);
  background: rgba($color: #000000, $alpha: 0.5);
  border-radius: 12px;
  text-align: center;
  padding: 0px 30px;
  cursor: pointer;

  i {
    transform: rotate(90deg);
    margin-right: 3px;
  }
}

.group-item-id {
  display: inline-flex;
  height: 16px;
  background: #4064a6;
  border-radius: 37px;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  padding: 2px 5px;
  color: #fff;

  img {
    margin-right: 2px;
  }
}

.bar-offset-14 {
  margin-left: -14px;
}

.check1-dialog .el-dialog__body {
  padding: 0;
  height: calc(100% - 120px);
}

.check1-dialog .el-dialog__footer {
  padding: 24px;
  border-top: 1px solid #2d3052;
}

.radio-button-mini {
  padding: 5px 14px;
  border-radius: 6px;

  &.el-button--danger.is-plain {
    background-color: transparent;
    color: #ff4d5b;
    border-color: #ff4d5b;
  }
}

.chat-auditImg {
  width: 100px;
  height: 100px;
  vertical-align: top;
  object-fit: contain;
}

.chat-link {
  text-decoration: underline;
}

.cla-system-link {
  text-decoration: underline;
  color: #fff;
}

.audit-bottom {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
}

.audit-top {
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
}

.noAuditList {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% - 50px);
  margin: auto;
}
.user-list {
  position: absolute;
  z-index: 1000;
  background: #2e3052;
  width: 130px;
  max-height: 155px;
  top: 0;
  left: 0;
  color: #fff;
  overflow-y: auto;
  font-size: 12px;
  opacity: 0;
  transition: opacity 500ms;

  li {
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 0 5px;
    &:hover {
      background: #434564;
    }
    img {
      margin-right: 4px;
    }
    &.selected {
      background: #434564;
    }
  }
}
[data-theme='Orange'] .user-list {
  background: #f0f0f0;
  color: #494a4d;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  li {
    &:hover {
      background: #f5f5f5;
    }
    &.selected {
      background: #f5f5f5;
    }
  }
}
// .user-list::after{
//     content: "";
//     position: absolute;
//     width: 0;
//     height: 0;
//     left: 50%;
//     bottom: -8px; /* 箭头高度的一半 */
//     transform: translateX(-50%);
//     border-left: 4px solid transparent;
//     border-right: 4px solid transparent;
//     border-top: 4px solid black;
// }
.at-message {
  position: absolute;
  z-index: 1000;
  font-size: 12px;
  color: #ea484b;
  right: 15px;
  bottom: 170px;
  width: 88px;
  height: 26px;
  background: #333a64;
  border-radius: 13px;
  border: 1px solid #ea484b;
  line-height: 26px;
  cursor: pointer;
}
[data-theme='Orange'] .at-message {
  background: #f0f0f0;
}
.list-name {
  display: inline-block;
  max-width: 95px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
